import { render, staticRenderFns } from "./NotasTable.vue?vue&type=template&id=0f0711da&"
import script from "./NotasTable.vue?vue&type=script&lang=js&"
export * from "./NotasTable.vue?vue&type=script&lang=js&"
import style0 from "./NotasTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QToolbar,QToolbarTitle,QBtn,QTimeline,QTimelineEntry} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QToolbar,QToolbarTitle,QBtn,QTimeline,QTimelineEntry})
